import {Box} from '@mui/material';
import {PlannerAnniversaryItem} from '../planner-item';
import {CakeOutlined} from '@mui/icons-material';
import {fadeIn} from '../../../../../../../../utils/css-animations';

type PlannerListAnniversaryItemProps = {
  item: PlannerAnniversaryItem;
  selected?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
};

export function PlannerListAnniversaryItem({
  item,
  selected,
  ...rest
}: PlannerListAnniversaryItemProps) {
  return (
    <Box
      sx={{
        flex: '1',
        bgcolor: 'secondary.light',
        fontWeight: '500',
        color: 'gray.main',
        borderRadius: '5px',
        padding: '3px',
        display: 'flex',
        alignItems: 'center',
        animation: `${fadeIn} 0.5s`,
        backgroundColor: selected ? 'blue.hover' : undefined,
        '&:hover': {
          backgroundColor: 'blue.hover',
          cursor: 'pointer',
          borderRadius: '5px',
        },
      }}
      {...rest}
    >
      <CakeOutlined
        sx={{
          fontSize: '16px',
          color: 'gray.main',
          marginRight: '5px',
          display: 'flex',
          flexDirection: 'column',
          placeSelf: 'center',
        }}
      />
      {item.user.name}
    </Box>
  );
}
